<template>
  <div class="min-h-screen flex items-center justify-center px-4">
    <UCard class="w-full max-w-md">
      <template #header>
        <div class="text-center">
          <h1 class="text-2xl font-bold text-gray-900">Recuperar senha</h1>
          <p class="mt-1 text-sm text-gray-500">
            Insira seu email para receber o link de recuperacao
          </p>
        </div>
      </template>

      <form @submit.prevent="handleSubmit" class="space-y-4">
        <UFormGroup label="Email" required>
          <UInput
            v-model="email"
            type="email"
            placeholder="seu@email.com"
            icon="i-heroicons-envelope"
            :disabled="sent"
          />
        </UFormGroup>

        <UButton type="submit" color="primary" block :loading="loading" :disabled="!email || sent">
          {{ sent ? "Email enviado!" : "Enviar link" }}
        </UButton>
      </form>

      <template #footer>
        <UButton to="/auth/login" variant="link" color="gray" block size="sm">
          Voltar ao login
        </UButton>
      </template>
    </UCard>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "auth",
  middleware: "guest",
});

const config = useRuntimeConfig();
const toast = useToast();
const axios = (await import("axios")).default;

const email = ref("");
const loading = ref(false);
const sent = ref(false);

async function handleSubmit() {
  loading.value = true;
  try {
    await axios.post(`${config.public.apiBase}/auth/password/reset`, { email: email.value });
    sent.value = true;
    toast.add({ title: "Sucesso", description: "Email enviado. Verifique sua caixa de entrada." });
  } catch {
    toast.add({ title: "Erro", description: "Falha ao enviar o email. Tente novamente.", color: "red" });
  } finally {
    loading.value = false;
  }
}
</script>

